import { component } from 'picoapp'

export default component((node) => {
    const activeColor = node.querySelector('[data-color]')
    const currentColor = activeColor.textContent
    const colors = node.querySelectorAll('[data-product-color]')

    colors.forEach((color) => {
        color.addEventListener('mouseenter', () => {
            activeColor.textContent = color.dataset.productColor
        })

        color.addEventListener('mouseleave', () => {
            activeColor.textContent = currentColor;
        })
    })
})
